export const PRODUCT_TYPE = {
    FootWear: 'Footwear',
};
